import "./Projects.css";
import ProjectCard from "./ProjectCard";

export default function Projects() {
  return (
    <>
      <div className="projectsContainer">
        <h1 className="subHeading">My Projects</h1>

        <div className="projects-grid">
          <ProjectCard
            title="Turnip Tracker"
            description="A comprehensive Animal Crossing turnip price tracker and profit calculator! Track daily prices, visualize trends with interactive charts, and maximize your bell profits with smart predictions."
            techStack={["Svelte", "Chart.js", "JavaScript", "CSS"]}
            link="https://turniptracker.netlify.app/"
            icon="🥬"
          />

          <ProjectCard
            title="TasteNYC"
            description="Your go-to app for discovering the best Asian cuisine in New York City! Filter restaurants based on your cravings, explore hidden gems, and check out handpicked recommendations for must-try spots."
            techStack={["React", "JavaScript", "CSS", "API Integration"]}
            link="https://tastenyc.netlify.app/"
            icon="🍕"
          />

          <ProjectCard
            title="Momo Gallery"
            description="A dynamic image gallery dedicated to our beloved Georgia Tech cat Momo! Meet this adorable cat and check out brilliant pictures taken by the Georgia Tech community."
            techStack={["HTML", "CSS", "JavaScript", "Responsive Design"]}
            link="https://momogallery.netlify.app"
            icon="📸"
          />

          <ProjectCard
            title="Split with Friends"
            description="Tired of keeping track of how much people owe you? This app manages splitting your bills with friends, making group expenses simple and transparent."
            techStack={["React", "JavaScript", "Local Storage", "CSS"]}
            link="https://splitwithfriends.netlify.app/"
            icon="💰"
          />
        </div>

        <div className="coming-soon">
          <h3>More projects coming soon... 🚀</h3>
        </div>
      </div>
    </>
  );
}
